// two bobby: share buttons. Native share sheet where available, WhatsApp link otherwise.
// A shared bag becomes a link that rebuilds the bag on arrival (collection.shared-bag template).
async function bagUrl() {
  const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
  if (!cart.items.length) return null;
  const bag = cart.items.map((i) => `${i.variant_id}:${i.quantity}`).join(',');
  return `${location.origin}/collections/all?view=shared-bag&bag=${encodeURIComponent(bag)}&ref=share`;
}

document.addEventListener('click', async (event) => {
  const btn = event.target.closest('[data-tb-share]');
  if (!btn) return;
  event.preventDefault();

  const mode = btn.dataset.tbShare;
  let url = btn.dataset.tbShareUrl;
  const text = btn.dataset.tbShareText;
  const title = btn.dataset.tbShareTitle;

  if (mode === 'bag') {
    url = await bagUrl();
    if (!url) {
      btn.querySelector('span').textContent = 'Your cart is empty';
      return;
    }
  }

  try {
    window.Shopify && Shopify.analytics && Shopify.analytics.publish('tb_share', { mode, placement: btn.dataset.tbSharePlacement, url: location.pathname });
  } catch (e) {}

  if (navigator.share) {
    try {
      await navigator.share({ title, text, url });
      return;
    } catch (e) {
      if (e && e.name === 'AbortError') return;
    }
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`, '_blank', 'noopener');
});
